import { useLiveQuery } from "@hq/client-react";
import { Outlet } from "@tanstack/react-router";
import { Suspense, useEffect } from "react";
import { useAppConfig } from "../AppConfig";
import { useTemplatePicker } from "../actions/TemplatePickerContext";
import { useRegisterActions } from "../actions/useRegisterActions";
import { applyTheme, THEME_KV_KEY, type ThemePreference } from "../theme";
import { Workspace } from "../workspace/Workspace";
import { WorkspaceNavigation } from "./WorkspaceNavigation";
import { StatusBar } from "./StatusBar";
import { TemplatePicker } from "./TemplatePicker";
import { WorkspaceLoading } from "./WorkspaceLoading";

function ThemeSync() {
  const { data: theme } = useLiveQuery(["kv"], (s) => s.kv.get<ThemePreference>(THEME_KV_KEY), []);
  useEffect(() => {
    applyTheme(theme);
  }, [theme]);
  return null;
}

function Ready(props: { onReady: (() => void) | undefined }) {
  const { onReady } = props;
  useEffect(() => {
    onReady?.();
  }, [onReady]);
  return null;
}

function Actions() {
  useRegisterActions();
  const picker = useTemplatePicker();
  return (
    <TemplatePicker
      open={picker.isOpen}
      onOpenChange={(o) => (o ? picker.open() : picker.close())}
    />
  );
}

export function Shell() {
  const { onReady } = useAppConfig();
  return (
    <Suspense fallback={<WorkspaceLoading />}>
      <div className="flex h-full min-h-0 flex-col bg-bg text-fg">
        <ThemeSync />
        <div className="flex min-h-0 flex-1 flex-col lg:flex-row">
          <Workspace>
            <WorkspaceNavigation />
            <Actions />
            {/* Route components open panes; they render nothing visible. */}
            <Outlet />
            <Ready onReady={onReady} />
          </Workspace>
        </div>
        <StatusBar />
      </div>
    </Suspense>
  );
}
